import React from 'react';

type DocumentStatus =
  | 'not_uploaded' |'uploaded' |'under_review' |'verified' |'rejected' |'missing' |'resubmission_required';

type SubmissionStatus =
  | 'draft' |'submitted' |'under_review' |'verified' |'rejected' |'resubmission_required' |'incomplete';

type AnyStatus = DocumentStatus | SubmissionStatus;

const statusConfig: Record<AnyStatus, { label: string; className: string; dot: string }> = {
  not_uploaded: {
    label: 'Not Uploaded',
    className: 'bg-zinc-100 text-zinc-600',
    dot: 'bg-zinc-400',
  },
  uploaded: {
    label: 'Uploaded',
    className: 'text-blue-700',
    dot: 'bg-blue-500',
  },
  under_review: {
    label: 'Under Review',
    className: 'text-cyan-700',
    dot: 'bg-cyan-500',
  },
  verified: {
    label: 'Verified',
    className: 'text-green-700',
    dot: 'bg-green-500',
  },
  rejected: {
    label: 'Rejected',
    className: 'text-red-700',
    dot: 'bg-red-500',
  },
  missing: {
    label: 'Missing',
    className: 'text-purple-700',
    dot: 'bg-purple-500',
  },
  resubmission_required: {
    label: 'Resubmit',
    className: 'text-amber-700',
    dot: 'bg-amber-500',
  },
  draft: {
    label: 'Draft',
    className: 'bg-zinc-100 text-zinc-600',
    dot: 'bg-zinc-400',
  },
  submitted: {
    label: 'Submitted',
    className: 'text-blue-700',
    dot: 'bg-blue-500',
  },
  incomplete: {
    label: 'Incomplete',
    className: 'text-amber-700',
    dot: 'bg-amber-500',
  },
};

interface StatusBadgeProps {
  status: AnyStatus;
  size?: 'sm' | 'md';
}

export default function StatusBadge({ status, size = 'md' }: StatusBadgeProps) {
  const config = statusConfig[status] || statusConfig['not_uploaded'];
  const bgClass = config.className.includes('bg-') ? config.className : `${config.className} bg-current/10`;

  const sizeClass = size === 'sm' ? 'px-1.5 py-0.5 text-[10px]' : 'px-2 py-0.5 text-xs';

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full font-semibold ${sizeClass} ${
        config.className.includes('bg-') ? config.className : ''
      }`}
      style={
        !config.className.includes('bg-')
          ? {
              backgroundColor: `color-mix(in srgb, currentColor 12%, transparent)`,
            }
          : {}
      }
    >
      <span
        className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${config.dot}`}
      />
      {config.label}
    </span>
  );
}